import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';

import PageHeaderSection from 'components/page/PageHeaderSection';
import PageSectionContainer from 'components/page/PageSectionContainer';

// Shown in place of an article the reader's Tovertafel doesn't have My Tover for —
// signing in wouldn't help here (see ArticleContainer's refusedBecause and ContentPage's
// 403 branch, both of which render this), so it's a different refusal from "sign in".
export const MyToverRequiredNotice = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeaderSection title={t('article.locked.title')} />

      <PageSectionContainer>
        <Box sx={{ mb: 4 }}>
          <Typography id="article-mytover-required">{t('error.403.no-mytover')}</Typography>
        </Box>

        <Box>
          <Button color="secondary" component={RouterLink} to="/request-invite">
            {t('opl.dialog.actions.request')}
          </Button>
        </Box>
      </PageSectionContainer>
    </>
  );
};

export default MyToverRequiredNotice;
